import React from 'react';
import './eventButton.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { routingStore } from '../../../../common/stores/routing';
import { V2Routes } from '../../../routes';
// FIXME: 本番環境で sentry の無限 loop が発生してブラウザが固まるので一時的に無効にする
// import { SpecialEventEvents } from '../../../../commonv3/events/SpecialEventEvents';
import { EventDetails, EventStatus, UserEventReservationStatus } from '../../../types/event';

type Props =
  | {
      isSignedIn: true;
      loading: boolean;
      event: EventDetails;
      eventStatus: EventStatus;
      userEventReservationStatus: UserEventReservationStatus;
    }
  | {
      isSignedIn: false;
      loading: boolean;
      event: EventDetails;
      eventStatus: EventStatus;
    };

type ButtonState =
  | {
      disabled: true;
      buttonLabel: string;
    }
  | {
      disabled: false;
      buttonLabel: string;
      href?: string;
      onClick?: () => void;
    };

const getButtonState = (props: Props): ButtonState => {
  const { event, eventStatus, isSignedIn } = props;
  // 終了している場合は常に終了
  if (eventStatus === 'is_past') {
    return {
      buttonLabel: '終了しました',
      disabled: true,
    };
  }

  if (eventStatus === 'archived') {
    if (isSignedIn && props.userEventReservationStatus.hasAffordableTokenForNow) {
      return {
        buttonLabel: '動画を見る',
        disabled: false,
        href: event.archive_video.url,
        // onClick: () => SpecialEventEvents.reportViewArchive(event),
      };
    } else {
      return {
        buttonLabel: '終了しました',
        disabled: true,
      };
    }
  }

  // ライブ配信中は予約している人のみが閲覧可能
  if (eventStatus === 'live_casting') {
    if (isSignedIn && props.userEventReservationStatus.reserved) {
      return {
        buttonLabel: 'ライブ配信を見る',
        disabled: false,
        href: event.archive_video.url,
        // onClick: () => SpecialEventEvents.reportViewLive(event),
      };
    }
  }

  if (isSignedIn && props.userEventReservationStatus.reserved) {
    return {
      buttonLabel: '予約済み',
      disabled: true,
    };
  }

  if (eventStatus === 'is_full') {
    return {
      buttonLabel: '満員御礼',
      disabled: true,
    };
  }

  return {
    buttonLabel: 'このイベントを予約する',
    disabled: false,
    onClick: () => routingStore.push(V2Routes.eventReservationPage(event.id)),
  };
};

// TODO: ボタンが Loading に対応していないので、デザインを適用するタイミングで Loading 中のボタンを表示するようにする
export const EventButton = (props: Props) => {
  const buttonState = getButtonState(props);
  return (
    <Button
      className="reservation-button"
      testid="event-reservation-button"
      type="primary"
      size="l"
      loading={props.loading}
      disabled={buttonState.disabled}
      href={buttonState.disabled ? undefined : buttonState.href}
      onClick={buttonState.disabled ? undefined : () => buttonState.onClick?.()}
    >
      {buttonState.buttonLabel}
    </Button>
  );
};
